export default "__VITE_ASSET__7a6a632b__"